import React, { useState, useEffect } from 'react';
import { withMetrics } from '@catalogo/core-metrics';
import { Input, WrapperInput, Magnifier, IconClose, SearchBox, WrapperTitle, Title } from './styled';
import { ISearchField } from '../../../types';

export const SearchFieldComponent = ({ fetchMore, term = '', onChange, dispatchMetrics, isDesk }: ISearchField) => {
  const [previousTerm, setPreviousTerm] = useState('');
  const placeholderText = isDesk ? 'busque por um termo sobre o produto' : 'busque por um termo';

  const fetchMoreQuestions = async () => {
    const sanitazedTerm = term.trim();
    if (previousTerm !== sanitazedTerm) {
      dispatchMetrics('event:track', {
        category: 'qna-pdp',
        action: `busca`,
        label: term,
      });
      await fetchMore({ loadingTarget: 'all', term });
      setPreviousTerm(sanitazedTerm);
    }
  };

  useEffect(() => {
    if (!term && previousTerm) {
      fetchMoreQuestions();
    }
  }, [term]);

  const handleKeyPress = (e: { persist: () => void; charCode: number }) => {
    e.persist();
    if (e.charCode === 13) {
      fetchMoreQuestions();
    }
  };

  const renderClose = term && <IconClose onClick={() => onChange({ target: { value: '' } })} />;

  return (
    <>
      <WrapperTitle isDesk={isDesk}>
        <Title isDesk={isDesk}>Confira se já existe uma resposta pra sua dúvida</Title>
      </WrapperTitle>
      <SearchBox>
        <WrapperInput isDesk={isDesk}>
          <Magnifier onClick={fetchMoreQuestions} />
          <Input
            onKeyPress={handleKeyPress}
            value={term}
            placeholder={placeholderText}
            onChange={onChange}
            isDesk={isDesk}
          />
          {renderClose}
        </WrapperInput>
      </SearchBox>
    </>
  );
};

const SearchField = withMetrics(SearchFieldComponent);

export { SearchField };
